import React from 'react';

const VendorsPage = () => {
  return <div>Venders Page</div>;
};

export default VendorsPage;
